var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C22.4464 39.9999 24.7899 39.5599 26.9565 38.756L27.8261 19.9999L26.9565 1.24392C24.7899 0.440017 22.4464 -6.10352e-05 20 -6.10352e-05C17.5536 -6.10352e-05 15.2101 0.440017 13.0435 1.24392L12.1739 19.9999L13.0434 38.756C15.2101 39.5599 17.5536 39.9999 20 39.9999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 28.5993 5.4275 35.9301 13.0435 38.756V1.24396C5.4275 4.06982 0 11.4007 0 20Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9566 1.24396V38.7561C34.5726 35.9301 40.0001 28.5993 40.0001 20C40.0001 11.4007 34.5726 4.06982 26.9566 1.24396V1.24396Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56512 19.9999H11.3043V26.9564H9.56512V19.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60858 19.9999H4.34772V26.9564H2.60858V19.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9563 24.3478C7.91681 24.3478 8.69544 23.5691 8.69544 22.6086C8.69544 21.6481 7.91681 20.8695 6.9563 20.8695C5.9958 20.8695 5.21716 21.6481 5.21716 22.6086C5.21716 23.5691 5.9958 24.3478 6.9563 24.3478Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95645 17.3913C7.43667 17.3913 7.82598 17.002 7.82598 16.5218C7.82598 16.0415 7.43667 15.6522 6.95645 15.6522C6.47622 15.6522 6.08691 16.0415 6.08691 16.5218C6.08691 17.002 6.47622 17.3913 6.95645 17.3913Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21729 25.2174H8.69557V26.9565H5.21729V25.2174Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21729 18.2609H8.69557V20H5.21729V18.2609Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95633 10.4348L7.57227 12.3301H9.56508L7.95297 13.5015L8.56844 15.3968L6.95633 14.2254L5.3443 15.3968L5.95977 13.5015L4.34766 12.3301H6.34047L6.95633 10.4348Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongolia);
export default __webpack_public_path__ + "static/media/mongolia.c7b5d0694f2723b314889b992e91b1f0.svg";
export { ForwardRef as ReactComponent };